import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
const includes = [['📚', '6 Complete Volumes'], ['🎁', '5 Exclusive Bonuses'], ['💬', '200 Reflection Questions'], ['🔮', 'Therapeutic Tarot Spreads'], ['📋', 'Session & Progress Tools'], ['🌙', 'Astrology, Grounding & Ethics']];
export function PricingPack() {
  return <section className="w-full bg-mist px-4 py-12 sm:py-14" data-id="element-162" data-mp="15bhc9rdkhm1r">
      <Reveal className="mx-auto max-w-[580px]" data-id="element-163" data-mp="1t4pr3g2n1hsx">
        <div id="complete-package" className="scroll-mt-4 overflow-hidden rounded-2xl border border-navy/10 bg-surface shadow-elevated" data-id="element-164" data-mp="1y2hfw17zknsw">
          <div className="bg-navy px-6 py-4 text-center text-sm font-bold leading-snug text-white" style={{
          color: "#22324A",
          backgroundColor: "#F5EFE0",
          backgroundImage: "none"
        }} data-id="element-165" data-mp="1k2gjaxyr82j8">
            🧘 Complete Package — One-Time Payment — No Subscriptions
          </div>

          <div className="px-6 pb-8 pt-8 sm:px-9" data-id="element-166" data-mp="cq7nineswbnq">
            <h2 className="text-center font-serif text-3xl leading-[1.15] text-navy sm:text-4xl" data-id="element-167" data-mp="cmtp1q99cmlk">
              THERAPEUTIC TAROT GUIDE™
            </h2>

            <p className="mt-5 text-center text-sm font-bold uppercase tracking-[0.1em] text-sage" data-id="element-168" data-mp="cxpew1xhsr6p">
              📦 Everything You Get Instantly
            </p>

            <ul className="mx-auto mt-5 max-w-sm space-y-3" data-id="element-169" data-mp="mutvznchdwgn">
              {includes.map(([icon, label]) => <li key={label} className="flex items-start gap-2.5 text-[15px] text-slate" data-id="element-170" data-mp="10tl4mu8kqpxe">
                  <span aria-hidden="true" data-id="element-171" data-mp="vvs0e6qu05zr">{icon}</span>
                  <span className="font-medium" data-id="element-172" data-mp="vt5qw1kdrgew">{label}</span>
                </li>)}
            </ul>

            <div className="mt-8 border-t border-navy/10 pt-6 text-center" data-id="element-173" data-mp="15l357h6oqohu">
              <p className="text-sm font-bold text-navy" data-id="element-174" data-mp="15luyumgq2c5h">Total Value $102 USD</p>

              <span className="mt-3 inline-block rounded-full bg-[#E8B53C] px-5 py-2 text-sm font-extrabold tracking-wide text-navy" data-id="element-175" data-mp="1jldwumftk742">
                YOU SAVE <span className="line-through" data-id="element-176" data-mp="c8bvtzmohsqy">$75 USD</span>
              </span>

              <div className="mt-5 font-serif text-6xl leading-none text-navy sm:text-7xl" data-id="element-177" data-mp="c68wuq3jspa3">
                $27<span className="align-super text-2xl font-bold sm:text-3xl" data-id="element-178" data-mp="h5c2abnfwxil">USD</span>
              </div>

              <p className="mx-auto mt-3 max-w-xs text-sm leading-6 text-slate" data-id="element-179" data-mp="l76y50mlqioz">
                One-time payment · No hidden fees · Pay in your local currency
              </p>

              <div className="mt-6" data-id="element-180" data-mp="uyl7e04cuwvb">
                <CTAButton size="large" fullWidthMobile={false} className="w-full text-lg tracking-[0.06em]" data-id="element-181" data-mp="zxnzkjz8l8lv">
                  GET INSTANT ACCESS
                </CTAButton>
              </div>

              <p className="mt-4 text-xs leading-6 text-slate" data-id="element-182" data-mp="18wi4qyqmv7b1">
                🔒 Secure Payment · 💳 Card · 🌎 Local Currency &amp; Payment Options · ⚡ Instant
                Access · ♾️ Lifetime Access
              </p>
            </div>
          </div>
        </div>
      </Reveal>
    </section>;
}